import { searchFieldWrapperStyles } from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import { css } from "styled-components";

searchFieldWrapperStyles.wrapper = {
    css: css`
            padding: 10px;
            width: 100%;
            > div {
                div[class^="FormInputWrapper"] {
                    input {
                        height: 40px !important;
                    }
            }
            }
        `,
    }
